import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Forms Selectors Definition.
 *
 * @namespace FormsSelectors
 */

var selectors = function selectors() {
  _classCallCheck(this, selectors);
};

_defineProperty(selectors, "moduleName", 'IEGForms');

_defineProperty(selectors, "getPageDetails", function (state) {
  return state[selectors.moduleName].pageDetails.payload;
});

_defineProperty(selectors, "getFormId", function (state) {
  return state[selectors.moduleName].formId.payload;
});

_defineProperty(selectors, "getPageDetailsError", function (state) {
  return state[selectors.moduleName].pageDetailsError.payload;
});

_defineProperty(selectors, "getSendPageAnswersError", function (state) {
  return state[selectors.moduleName].sendPageAnswersError.payload;
});

_defineProperty(selectors, "deleteSummaryPageRecordError", function (state) {
  return state[selectors.moduleName].deleteSummaryPageRecordError.payload;
});

_defineProperty(selectors, "isSubmitEnabled", function (state) {
  return state[selectors.moduleName].submitEnabled.payload;
});

_defineProperty(selectors, "isPostingGoToPage", function (state) {
  return state[selectors.moduleName].isPostingGoToPage.payload;
});

_defineProperty(selectors, "goToPageError", function (state) {
  return state[selectors.moduleName].goToPageError.payload;
});

export { selectors as default };